<script setup lang="ts">
import { Translation } from 'vue-i18n';

import { AppButton } from '@libs/ui';

import seaportImage from '../../../../../../assets/add_ferry.png';

interface AppStenaFerryCardDesktopEmits {
  (eventName: 'add'): void;
}

const emit = defineEmits<AppStenaFerryCardDesktopEmits>();
</script>

<template>
  <div class="add-stena-ferry-card-desktop">
    <div class="image">
      <img :src="seaportImage" :alt="$t('a11y.ferry_image')" />
      <div class="sale">{{ $t('planner.transport.upsell.sale') }}</div>
    </div>
    <div class="content">
      <div class="info-wrapper">
        <div class="header">
          {{ $t('planner.transport.upsell.stena_ferry.title') }}
        </div>
        <div class="description">
          <Translation
            keypath="planner.transport.upsell.stena_ferry.paragraph_one"
            tag="span"
          >
            <template #discount>
              <span class="highlighted">
                {{ $t('planner.transport.upsell.stena_ferry.discount') }}
              </span>
            </template>
          </Translation>

          <span>
            {{ $t('planner.transport.upsell.stena_ferry.paragraph_two') }}
          </span>
        </div>
      </div>

      <AppButton
        class="button"
        type="secondary"
        state="enabled"
        size="small"
        :left-icon="{ name: 'plus' }"
        @click="emit('add')"
      >
        {{ $t('planner.transport.add_ferry') }}
      </AppButton>
    </div>
  </div>
</template>

<style scoped lang="scss">
.add-stena-ferry-card-desktop {
  display: grid;
  grid-template-columns: 30% 70%;

  box-shadow: var(--shadow-elevation-200);
  border-radius: var(--border-radius-12);
  overflow: hidden;

  @include for-less-or-equal-than-1535-px {
    grid-template-columns: 45% 55%;
  }

  @include for-less-or-equal-than-1199-px {
    grid-template-columns: 30% 70%;
  }

  @include for-less-or-equal-than-899-px {
    grid-template-columns: 45% 55%;
  }

  .image {
    position: relative;

    .sale {
      position: absolute;
      top: 0;
      left: 0;
      width: fit-content;

      background-color: var(--color-neutral-40);
      padding: var(--spacing-12);
      @include font-label-s-bold;

      display: flex;
      align-items: center;
      justify-content: center;
    }

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }

  .content {
    padding: var(--spacing-16);
    background-color: var(--color-white);

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: var(--spacing-16);

    .info-wrapper {
      .header {
        @include font-heading-5;
        color: var(--color-neutral-70);
        margin-bottom: var(--spacing-12);
      }

      .description {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-8);
        @include font-body-s-light;
        color: var(--color-neutral-70);

        .highlighted {
          @include font-body-s-bold;
        }
      }
    }
    .button {
      width: fit-content;
    }
  }
}
</style>
